export function formatToIsoDate(date: string): string {
  if (!date || !/^\d{2}\/\d{2}\/\d{4}$/.test(date)) return date;
  const [day, month, year] = date.split('/');
  return `${year}-${month}-${day}`;
}
